module.exports = __webpack_public_path__ + "static/img/p_icon3.bdd4c08c.png";